// removed by extract-text-webpack-plugin
module.exports = {"primary-menu":"main_nav-ulY","menu-link":"main_nav-x93","secondary-menu":"main_nav-pUx","wrapper":"main_nav-Smo","mobile-collapsed":"main_nav-101","container":"main_nav-3rM","searching":"main_nav-1cF"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Menu/menu.module.scss
// module id = 24
// module chunks = 0